
export const collectFileData = (file) => {
  if (!file) return null;

  return {
    name: file.name,
    size: file.size + ' bytes',
    type: file.type || 'unknown',
    lastModified: new Date(file.lastModified).toLocaleString(),
    extension: file.name.split('.').pop().toLowerCase(),
  };
};
